export default __webpack_public_path__ + "static/media/person_2@2x.f6aa6b21.png";